<aside class="sidebar" [class.sidebar-collapsed]="isCollapsed">
  <div class="sidebar-top">
    <div class="sidebar-header">
      <div class="logo-box" [class.hidden-when-collapsed]="isCollapsed">
        <img [src]="themeService.currentTheme() === 'dark' ? '/logo-dark.png' : '/logo-sidebar.png'" alt="copago Logo"
          class="login-logo" />
      </div>

      <button mat-icon-button type="button" class="collapse-button" (click)="onToggleCollapsed()"
        [attr.aria-label]="isCollapsed ? 'Sidebar öffnen' : 'Sidebar schließen'">
        <mat-icon fontSet="material-icons-outlined">
          {{ isCollapsed ? 'chevron_right' : 'chevron_left' }}
        </mat-icon>
      </button>
    </div>

    <nav class="nav-list">
      @for (item of navItems(); track item.route) {
      <a class="nav-item" [routerLink]="item.route" routerLinkActive="nav-item-active"
        [matTooltip]="isCollapsed ? item.label : ''" matTooltipPosition="right" matTooltipClass="sidebar-tooltip"
        (click)="onNavigate()">
        <div class="nav-item-left">
          <mat-icon class="nav-icon" fontSet="material-icons-outlined">
            {{ item.icon }}
          </mat-icon>

          <span class="nav-label" [class.hidden-when-collapsed]="isCollapsed">
            {{ item.label }}
          </span>
        </div>

        @if (item.badge !== undefined && item.badge !== null) {
        <span class="nav-badge" [class.hidden-when-collapsed]="isCollapsed">
          {{ item.badge }}
        </span>
        }
      </a>
      }
    </nav>
  </div>

  <div class="sidebar-bottom">
    <div class="theme-toggle-row" [class.mobile-hidden-actions]="isMobile">
      <button type="button" class="theme-switch-button"
        [class.theme-toggle-active]="themeService.currentTheme() === 'dark'"
        (click)="appSettingsService.toggleDarkMode()"
        [matTooltip]="isCollapsed ? (themeService.currentTheme() === 'dark' ? 'Light Mode' : 'Dark Mode') : ''"
        matTooltipPosition="right" matTooltipClass="sidebar-tooltip"
        [attr.aria-label]="themeService.currentTheme() === 'dark' ? 'Light Mode aktivieren' : 'Dark Mode aktivieren'">
        <span class="sidebar-theme-switch">
          <span class="sidebar-theme-switch-thumb">
            <mat-icon fontSet="material-icons-outlined">
              {{ themeService.currentTheme() === 'dark' ? 'dark_mode' : 'light_mode' }}
            </mat-icon>
          </span>
        </span>
      </button>

      <span class="theme-toggle-label" [class.hidden-when-collapsed]="isCollapsed">
        {{ themeService.currentTheme() === 'dark' ? 'Light Mode' : 'Dark Mode' }}
      </span>
    </div>

    <div class="user-name" [matTooltip]="isCollapsed ? userName : ''" matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip">
      <mat-icon class="logout-icon" fontSet="material-icons-outlined">person_outline</mat-icon>
      <span [class.hidden-when-collapsed]="isCollapsed">{{ userName }}</span>
    </div>

    <button type="button" class="logout-button" [class.mobile-hidden-actions]="isMobile" (click)="logout()"
      [matTooltip]="isCollapsed ? 'Abmelden' : ''" matTooltipPosition="right" matTooltipClass="sidebar-tooltip">
      <mat-icon class="logout-icon" fontSet="material-icons-outlined">logout</mat-icon>
      <span [class.hidden-when-collapsed]="isCollapsed">Abmelden</span>
    </button>
  </div>
</aside>